// The panel a PERSONAL engineer surface shows when the account driving the PWA has no engineer
// records of its own (Session AGV). See src/lib/pwaIdentity.ts for the rule and why it exists.
//
// It states the true reason rather than an error, and points at the office page that does hold
// what they came looking for. An admin reaching the PWA is signed in through the office Google
// flow, so that link resolves for them; it is rendered only for an oversight account, never for an
// engineer, who could not open it.
import { Link } from "react-router-dom";

export function OversightNotice({
  title,
  explanation,
  officeHref,
  officeLabel,
}: {
  title: string;
  explanation: string;
  officeHref?: string;
  officeLabel?: string;
}) {
  return (
    <div>
      <h1 className="mb-4 font-heading text-2xl tracking-wide text-ele-strong">{title}</h1>
      <div className="rounded-lg border border-ele-card-border bg-ele-card p-6 text-center">
        <p className="text-sm text-ele-strong">{explanation}</p>
        {officeHref && officeLabel && (
          <Link
            to={officeHref}
            className="mt-4 inline-flex min-h-11 items-center rounded-lg border border-[#2CB9F3] px-4 font-menu text-xs tracking-wide text-[var(--ele-loler-ink)]"
          >
            {officeLabel}
          </Link>
        )}
      </div>
    </div>
  );
}
